import * as THREE from 'three';
import TextMesh from '../../utils/textmesh.js';

export default class CategoryTrack {

    constructor(config) {

        let self = this;
        let defaultConfig = {
            width:self.trackwidth,
            depth:26000,
            data:{},
            slurp:(window.innerWidth < 600)? 15:35
        }

        // merge config with default
        this.config = deepmerge(defaultConfig, config);
        this._targetZ = this.config.depth / 2;

        document.addEventListener("camera_event", function (event) {
            self.doCameraEvent(event);
        });


    }

    get trackwidth(){
        let w = 4000;
        // if(window.innerWidth < 600) w = 1500;
        // if(window.innerWidth > 600 && window.innerWidth < 1025) w = 3200;

        if(window.innerWidth < 600){
            w = 1700;
        }else if (window.innerWidth > 600 && window.innerWidth < 1025) {
            w = 3200;
        }

        return w;
    }

    get trackcount(){
        return Object.keys(timelineData.events).length;
    }

    makeTrack(){

        this.trackObj = new THREE.Object3D();

        this.geometry = new THREE.PlaneBufferGeometry(8, this.config.depth, 1, 1);
        this.line_material = new THREE.MeshPhongMaterial({
            color: 0xffffff,
            fog:true,
            side: THREE.DoubleSide
        });

        // length tracks
        let i=0;
        let trackcount = this.trackcount;
        let fontsize;
        let textColour;
        // let fontsize   = (window.innerWidth < 600)? 2 : 3;
        if(window.innerWidth < 480){
            fontsize = 2.5;
            textColour = "rgba(0, 0, 0, 1)";
        }else if(window.innerWidth < 600){
            fontsize = 2;
            textColour = "rgba(0, 0, 0, 1)";
        }else{
            fontsize = 3;
            textColour = "rgba(255, 255, 255, 1)";
        }


        for(let track in timelineData.events){

            let line = this.addLine(i);

            let text_mesh = new TextMesh(
                {
                    fontsize: fontsize,
                    message: track,
                    textBGColour: timelineData.events[track][0].colour,
                    canvaswidth:Math.round(this.config.width / Object.keys( timelineData.events ).length),
                    textColour:textColour
                });

           // line.add(text_mesh);
          if(window.innerWidth > 600){line.add(text_mesh);}
            text_mesh.rotation.x = -Math.PI / 2;
            text_mesh.rotation.y = Math.PI;

            text_mesh.position.y = -(this.config.depth/2);
            text_mesh.position.z = 70;
            text_mesh.position.x = (this.trackwidth / trackcount) / 2;

            i++;

        }

        let line = this.addLine(i);

        this.trackObj.position.x = -this.config.width/2;
        this.trackObj.position.y = (window.innerWidth < 600)?600:500;
        this.trackObj.position.z = (this.config.depth / 2) - 1500;

        return this.trackObj;

    }

    set targetZ(targetZ){
        this._targetZ = targetZ;
    }

    get targetZ(){
        return this._targetZ;
    }

    doCameraEvent(cam_event){
        this.targetZ = (this.config.depth / 2) + cam_event.detail.data.data;
    }

    addLine(i){

        let line = new THREE.Mesh(this.geometry, this.line_material);
        this.trackObj.add(line);

        line.position.x = i*(this.config.width / Object.keys( timelineData.events ).length);
        line.rotation.x = Math.PI / 2;

        return line;
    }

    update(){
        for(let i = 0 ; i < this.trackObj.children.length ;i++){

           // if(this.trackObj.children[i].position.z != 0)console.log(this.trackObj.children[i]);

        }

        let currz   = this.trackObj.position.z;
        let targetz = currz + ((this.targetZ - currz) / this.config.slurp);
        this.trackObj.position.z = targetz;
    }


}



